import OwnerRoute from "../common/components/OwnerRoute";
import Payouts from "./pages/Payouts";

const payoutRoutes = [
  {
    path: "/payouts",
    element: (
      <OwnerRoute>
        <Payouts />
      </OwnerRoute>
    ),
  },
];

export default payoutRoutes;
